var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.18489 10.1968C1.61827 9.46068 1.33496 9.09262 1.33496 7.9997C1.33496 6.90678 1.61827 6.53872 2.18489 5.80259C3.31627 4.33274 5.2137 2.66637 8.00163 2.66637C10.7896 2.66637 12.687 4.33274 13.8184 5.80259C14.385 6.53872 14.6683 6.90678 14.6683 7.9997C14.6683 9.09262 14.385 9.46068 13.8184 10.1968C12.687 11.6667 10.7896 13.333 8.00163 13.333C5.2137 13.333 3.31627 11.6667 2.18489 10.1968Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.001 7.99986C10.001 9.10443 9.10555 9.99986 8.00098 9.99986C6.89641 9.99986 6.00098 9.10443 6.00098 7.99986C6.00098 6.89529 6.89641 5.99986 8.00098 5.99986C9.10555 5.99986 10.001 6.89529 10.001 7.99986Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye_open.3f05ceb5ea4d0d95fccdcf95ae411c86.svg";
export { ForwardRef as ReactComponent };